import React from 'react';

const Foot = () => {
	return (
		<div className="LayoutFoot">
			<div className="LayoutFoot_container">
				<div className="LayoutFoot_content">
					<div className="LayoutFoot_card">
						<span className="LayoutFoot_text">© {new Date().getFullYear()} Scotiabank All Rights Reserved</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Foot;